import React from "react";
import less from "./BusDetails.module.scss";
import MaxImages from "../../maxImages";

const busDetails = props => {
  const {
    booking,
    driverCabinSafetyEquipments,
    serviceTier,
    busPhotos = []
  } = props;
  const isElectric = booking?.trip?.service?.isElectric;
  const isFirstAidKitAvailable =
    booking?.trip?.service?.firstAidKits?.length > 0 ||
    driverCabinSafetyEquipments?.some(
      equipment => equipment === "FIRST_AID_KIT"
    );
  const showSeatLayoutOption =
    booking?.boardingPoint?.time - 3 * 60 * 60 * 1000 < Date.now();

  const isFireExtinguishersAvailable =
    (booking?.trip?.service?.fireExtinguishers &&
      booking?.trip?.service?.fireExtinguishers.length > 0) ||
    driverCabinSafetyEquipments?.some(
      equipment => equipment === "FIRE_EXTINGUISHER"
    );

  const emergencyHammersAvailable =
    (!!booking?.trip?.service?.emergencyHammers &&
      booking?.trip?.service?.emergencyHammers.some(
        hammer =>
          hammer.onEveryBackSeat ||
          hammer.onEveryWindowSeat ||
          (hammer.positions && hammer.positions.length > 0)
      )) ||
    driverCabinSafetyEquipments?.some(
      equipment => equipment === "EMERGENCY_HAMMER"
    );

  const exitCount = booking?.trip?.service?.exits?.length || 0;

  const hasSafetyEquipment =
    isFirstAidKitAvailable ||
    isFireExtinguishersAvailable ||
    emergencyHammersAvailable ||
    exitCount > 0;

  // Bus Details fetches /booking/busInfo by busId, so it has nothing to open without one.
  const hasBusId = !!booking?.trip?.busId;

  return (
    <div className={less.wrapper}>
      <div className={less.header}>
        <span>Bus Information</span>
        {hasBusId ? (
          <span onClick={props.showBusDetails}>{`Bus Details >`}</span>
        ) : null}
      </div>
      <div className={less.content}>
        <div className={less.tagRow}>
          <div className={less.tierTags}>
            {serviceTier === "PLUS" ? (
              <div className={less.plusTag}>
                <span>Plus</span>
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/plus_1789015517013.svg"
                  alt=""
                />
              </div>
            ) : null}
            {serviceTier === "MAXX" ? (
              <img
                className={less.maxxTag}
                src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/maxIcon_1789012606064.svg"
                alt="MAXX"
              />
            ) : null}
            {isElectric ? (
              <div className={less.electricTag}>
                <img
                  src="https://d1flzashw70bti.cloudfront.net/original/test/selfHelp/electricIcon_1789012477130.svg"
                  alt=""
                />
                <span>Electric</span>
              </div>
            ) : null}
          </div>
          <span className={less.rcPlate}>{props.busDetails.rc}</span>
        </div>
        {busPhotos.length ? (
          <div className={less.busPhotos}>
            {busPhotos.map(photo => (
              <img
                className={less.busPhoto}
                key={photo.url}
                src={photo.url}
                alt={photo.label || "bus"}
              />
            ))}
          </div>
        ) : null}

        {/* Audit photos are the source of truth; MAXX photos are only a fallback. */}
        {!busPhotos.length &&
        props.isMaxService &&
        props.maxPhotos &&
        props.maxPhotos.length ? (
          <MaxImages
            isMaxService={props.isMaxService}
            maxPhotos={props.maxPhotos}
          />
        ) : null}

        {props.busDetails.busType ? (
          <span className={less.busType}>{props.busDetails.busType}</span>
        ) : null}

        <div className={less.amenities}>
          <div>
            <img
              src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/blanket1.svg"
              alt="blanket"
            />
            <span>Blankets sanitized daily</span>
          </div>
          <div>
            <img
              src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/clean.svg"
              alt="clean"
            />
            <span>Recently cleaned bus </span>
          </div>
        </div>

        {hasSafetyEquipment ? (
          <>
            <div className={less.line}></div>
            <div className={less.emergencyHeader}>
              <span>EMERGENCY & SAFETY</span>
              {showSeatLayoutOption && (
                <span onClick={props.onViewSeatLayout}>View Seat Layout</span>
              )}
            </div>
            <div className={less.emergencyContent}>
              {isFirstAidKitAvailable && (
                <div>
                  <img
                    src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/medical.svg"
                    alt="kit"
                  />
                  <span>First aid kit</span>
                </div>
              )}
              {isFireExtinguishersAvailable && (
                <div>
                  <img
                    src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/fire_extinguisher.svg"
                    alt="fire"
                  />
                  <span>Fire extinguisher</span>
                </div>
              )}
              {emergencyHammersAvailable && (
                <div>
                  <img
                    src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/hardware.svg"
                    alt="hammer"
                  />
                  <span>Emergency hammer</span>
                </div>
              )}
              {exitCount > 0 && (
                <div>
                  <img
                    src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/door.svg"
                    alt="door"
                  />
                  <span>{exitCount} Emergency exits</span>
                </div>
              )}
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default busDetails;
